<div class="login-page">
  <div class="panel form-panel">
    <img class="logo" src="//cdn.tokeet.com/images/WhiteBackground_Logo_md.png" />
    <div class="upgrade-banner p-4">
      <div class="text-dark text-bold mb-2" style="font-size: 14px">You're using an older version of Tokeet.</div>
      <div class="mb-4">
        <a href="http://advance.cm/?utm_source=site&utm_medium=organic&utm_campaign=loginpage" target="_blank">
          <span class="text-bold" style="color: #03a99d">AdvanceCM</span>
        </a>
        is the latest version, log in with the same credentials, same backend. You can switch back anytime.
      </div>
      <a class="btn btn-primary text-white px-5" [href]="advanceCmUrl" style="background-color: #03a99d">
        <i class="fas fa-sparkles" style="font-size: 16px"></i>
        Login to AdvanceCM
      </a>
    </div>
    <div class="text-center my-4">
      <div class="text-muted" style="font-size: 10px">OR</div>
      <div class="text-dark" style="font-size: 12px; font-weight: 500">Continue with Tokeet</div>
    </div>

    <ng-content></ng-content>

    <div class="links">
      <a href="//www.tokeet.com/terms.html" target="_blank">Terms of Service</a> |
      <a href="//www.tokeet.com/privacy.html" target="_blank">Privacy Policy</a>
    </div>
  </div>

  <div class="panel intro-panel">
    <div class="intro-text text-header">Access the Tokeet suite of products with a single username and password.</div>
    <div class="intro-text">
      Tokeet is on a mission to simplify short-term rental management. With the most powerful platform on the market and
      a suite of robust tools for every step of the guest experience. Grow your business with Tokeet by doing more with
      less.
    </div>

    <div class="logos">
      <a href="//www.tokeet.com" target="_blank">
        <img alt="Tokeet Logo" src="/assets/images/logo/tokeet-light.png" />
      </a>
      <a href="//www.usesignature.com" target="_blank">
        <img alt="Signature Logo" src="/assets/images/logo/signature-light.png" />
      </a>
      <a href="//useautomata.com" target="_blank">
        <img alt="Automata Logo" src="/assets/images/logo/automata-light.png" />
      </a>
      <a href="//rategenie.io" target="_blank">
        <img alt="Rate Genie Logo" src="/assets/images/logo/rategenie-light.png" />
      </a>
      <a href="//www.ownercenter.net" target="_blank">
        <img alt="Owner Center Logo" src="//cdn.tokeet.com/images/logos/owners_right_sm.png" />
      </a>
      <a href="//www.tokeet.com/reports.html" target="_blank">
        <img alt="Margins Logo" src="//cdn.tokeet.com/images/logos/margin-white.png" />
      </a>
      <a href="//usechecklist.com" target="_blank">
        <img alt="Checklist Logo" src="/assets/images/logo/checklist-light.png" />
      </a>
      <a href="//sympl.cm" target="_blank">
        <img alt="Sympl Logo" src="/assets/images/logo/sympl-light.png" />
      </a>
      <a href="//usewebready.com" target="_blank">
        <img alt="Webready Logo" src="/assets/images/logo/webready-light.png" />
      </a>
      <a href="//advance.cm" target="_blank" class="position-relative">
        <img alt="AdvanceCM Logo" src="/assets/images/logo/advance-light.webp" />
        <span
          class="badge badge-primary badge-pill position-absolute"
          style="top: -10px; right: -10px; background-color: #0e5571; color: #fff"
        >
          <i class="fas fa-sparkles"></i>
          New
        </span>
      </a>
    </div>
  </div>
</div>
